export interface SalesOrderLineWebsite {
  id: string;
  salesOrderLineId: string;
  orderNo: string;
  sequence: string;
  customerName: string;
  deliveryAddress: string;
  customerOrderNo: string;
  customerOrderRef: string;
  orderStatus: string;
  productKey: string;
  productDescription: string;
  quantity: number;
  stockStatus: string;
  currency: string;
  price: number;
  lineValue: number;
  taxValue: number;
  totalValue: number;
  dateOrdered: Date;
  dateEntered: Date;
  dateAmended: Date;
  deliveryDate: Date;
  enteredBy: string;
  commentsExist: boolean;
}
